import React from 'react';

export const commaFormatted = (amount) => {
    const delimiter = ","; // replace comma if desired
    const aa = amount.split(".", 2);
    const d = aa[1];
    let i = parseInt(aa[0]);
    if (isNaN(i)) {
        return "";
    }

    let minus = "";
    if (i < 0) {
        minus = "-";
    }

    i = Math.abs(i);
    let n = String(i);
    const a = [];

    while (n.length > 3) {
        const nn = n.substr(n.length - 3);
        a.unshift(nn);
        n = n.substr(0, n.length - 3);
    }

    if (n.length > 0) {
        a.unshift(n);
    }

    n = a.join(delimiter);
    if (d) {
        if (d.length < 1) {
            amount = n;
        } else {
            amount = n + "." + d;
        }            
    } else {
        amount = n;
    }
    
    return '$' + amount;
};

export const FormatedLine = (props) => {
    const colorClass = props.content < 0 ? 'negNumber' :
        props.type === 'money-mobile' ? 'posNumber' : '';

    return (
        <span className={colorClass}>
            {props.content < 0 &&
                '('
            }
            {(props.type === "money" || props.type === "money-mobile") &&
                ((props.content && !isNaN(props.content)) ? commaFormatted(Math.round(props.content).toString()) : '0')
            }
            {(props.type !== "money" && props.type !== "money-mobile") &&
                ((props.content && !isNaN(props.content)) ? props.content > 0 ? props.content : (props.content * -1) : '0')
            }
            {props.content < 0 &&
                ')'
            }
        </span>
    )
}

export default FormatedLine;
